import i18n from '@/i18n'
const mutations = {
  setCart (state, cart) { state.cart = cart },
  setIsMobile (state, isMobileFlag) { state.isMobileFlag = isMobileFlag },
  setCartDialogFlag (state, cartDialogFlag) { state.cartDialogFlag = cartDialogFlag },
  setLoadingFlag (state, loading) { state.loading = loading },
  setUser (state, user) { state.user = user },
  changeLanguage(state, payload) {
    i18n.locale = payload
    state.lang = payload
  },
}
export default mutations
